var _createClass = require("/home/diana/Documents/dev/personal/wheely/wheely-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/home/diana/Documents/dev/personal/wheely/wheely-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _assertThisInitialized = require("/home/diana/Documents/dev/personal/wheely/wheely-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _inherits = require("/home/diana/Documents/dev/personal/wheely/wheely-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/diana/Documents/dev/personal/wheely/wheely-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _wrapNativeSuper = require("/home/diana/Documents/dev/personal/wheely/wheely-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
module.exports = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(NotFoundError, _Error);
  var _super = _createSuper(NotFoundError);
  function NotFoundError(message) {
    var _this;
    _classCallCheck(this, NotFoundError);
    _this = _super.call(this, message);
    Error.captureStackTrace(_assertThisInitialized(_this), NotFoundError);
    _this.name = NotFoundError.name;
    return _this;
  }
  return _createClass(NotFoundError);
}( /*#__PURE__*/_wrapNativeSuper(Error));